import { ArrowBigRight } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { DoubleButtonsEditorRenderer } from "./editor";
import { DoubleButtonsEmailRenderer } from "./email";
import type { DoubleButtonsBlock, DoubleButtonsBlockProps } from "./types";
import { DoubleButtonsEmailPanelRenderer } from "./email-panel";
import DoubleButtonsWeb from "./web";
import { DoubleButtonsWebEditor } from "./web-editor";

export default registerBlock<DoubleButtonsBlockProps>({
  type: "double-buttons",
  name: "editorBlocksLibrary.blocks.double-buttons.title",
  description: "editorBlocksLibrary.blocks.double-buttons.description",
  Icon: ArrowBigRight,
  category: BlockCategory.ESSENTIALS,
  isTranslated: (locale, block) => {
    const content = (block as DoubleButtonsBlock).content;

    return (
      !!content?.[locale]?.button0?.text?.length &&
      !!content?.[locale]?.button0?.href?.length &&
      !!content?.[locale]?.button1?.text?.length &&
      !!content?.[locale]?.button1?.href?.length
    );
  },
  components: {
    email: {
      component: DoubleButtonsEmailRenderer,
      editor: {
        component: DoubleButtonsEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: DoubleButtonsEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
    web: {
      component: DoubleButtonsWeb,
      editor: {
        component: DoubleButtonsWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: DoubleButtonsEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});

export type { DoubleButtonsBlockProps as DoubleButtonsEditorRendererProps } from "./types";
